/* eslint-disable */
export function number (number, decimal) {
  decimal = typeof decimal === 'undefined' ? 0 : decimal
  return formatNumber(number, decimal)
}

export function vnd (money, decimal) {
  decimal = typeof decimal === 'undefined' ? 0 : decimal
  return formatNumber(money, decimal) + ' đ'
}

export function yen(money) {
  return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(money)
}

export function gam (gam, decimal) {
  decimal = typeof decimal === 'undefined' ? 0 : decimal
  return formatNumber(gam, decimal) + ' g'
}

export function cm (cm, decimal) {
  decimal = typeof decimal === 'undefined' ? 0 : decimal
  return formatNumber(cm, decimal) + ' cm'
}

export function percent (percent, decimal) {
  decimal = typeof decimal === 'undefined' ? 0 : decimal
  return formatNumber(percent, decimal) + ' %'
}

function formatNumber (number, places, thousand, decimal) {
  number = number || 0
  places = !isNaN(places = Math.abs(places)) ? places : 2
  thousand = thousand || ','
  decimal = decimal || '.'
  let negative = number < 0 ? '-' : ''
  let i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + ''
  let j = i.length
  j = j > 3 ? (j % 3) : 0

  return negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '')
}

export function dateString (date) {
  let x = new Date(date)
  return x.toDateString()
}

export function string_to_slug (str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to   = "aaaaeeeeiiiioooouuuunc------";
  for (var i=0, l=from.length ; i<l ; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes

  return str;
}



// WEBPACK FOOTER //
// ./src/filters/index.js